import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';
import type { AiManagedObject } from '@atlassian/ai-managed-objects/types';

import {
	type AgentManagedExtensionMeta,
	type AgentManagedExtensionMetaAction,
	setMeta,
} from '../pm-plugins/state';

const dispatchMeta =
	(meta: AgentManagedExtensionMeta): EditorCommand =>
	({ tr }) => {
		setMeta(tr, meta);
		tr.setMeta('addToHistory', false);
		return tr;
	};

/** Open the inline configuration popup for the agent-managed block at the current selection. */
export const openConfig = (): EditorCommand => dispatchMeta({ type: 'OPEN_CONFIG' });

/** Close the inline configuration popup. */
export const closeConfig = (): EditorCommand => dispatchMeta({ type: 'CLOSE_CONFIG' });

/** Toggle the inline configuration popup. */
export const toggleConfig = (): EditorCommand => dispatchMeta({ type: 'TOGGLE_CONFIG' });

export const getCacheAiManagedObjectMeta = (
	aiManagedObject: AiManagedObject,
	localId?: string,
): AgentManagedExtensionMetaAction => ({
	aiManagedObject,
	localId,
	type: 'CACHE_AI_MANAGED_OBJECT',
});

const getStartAiManagedObjectLoadMeta = (
	aimoId: string,
	localId?: string,
): AgentManagedExtensionMetaAction => ({
	aimoId,
	localId,
	type: 'START_AIMO_LOAD',
});

const getFailAiManagedObjectLoadMeta = (
	aimoId: string,
	localId?: string,
): AgentManagedExtensionMetaAction => ({
	aimoId,
	localId,
	type: 'FAIL_AIMO_LOAD',
});

/** Cache a full AI-managed object in plugin state. */
export const cacheAiManagedObject = (
	aiManagedObject: AiManagedObject,
	localId?: string,
): EditorCommand => dispatchMeta(getCacheAiManagedObjectMeta(aiManagedObject, localId));

/** Mark an AI-managed object fetch as loading in plugin state. */
export const startAiManagedObjectLoad = (aimoId: string, localId?: string): EditorCommand =>
	dispatchMeta(getStartAiManagedObjectLoadMeta(aimoId, localId));

/** Mark an AI-managed object fetch as failed in plugin state. */
export const failAiManagedObjectLoad = (aimoId: string, localId?: string): EditorCommand =>
	dispatchMeta(getFailAiManagedObjectLoadMeta(aimoId, localId));
